import { usePermission } from './use-permission'

export function useResourcePermissions(module: string, resource: string) {
    const { canRead, canCreate, canUpdate, canDelete } = usePermission()

    return {
        canRead: canRead(module, resource),
        canCreate: canCreate(module, resource),
        canUpdate: canUpdate(module, resource),
        canDelete: canDelete(module, resource),
    }
}
